import axios from "@/services/config";

export const listarUsuarios = async (params) => {
  const { data, status } = await axios
    .get("/soporte/cmms/usuarios", { params })
    .catch((e) => e.response);
  return { data, status };
};

export const crearLicencia = async (datos) => {
  const { data, status } = await axios
    .post("/soporte/cmms/licencias", {
      IdTCompania: datos.IdTCompania,
      DescripcionCompania: datos.DescripcionCompania,
      Usuario: datos.Usuario,
    })
    .catch((e) => e.response);
  return { data, status };
};

export const generarQr = async (datos) => {
  const respuesta = await axios
    .post(
      "/soporte/cmms/qr",
      {
        Descripcion: datos.Descripcion,
        Cantidad: datos.Cantidad,
      },
      { responseType: "blob" }
    )
    .catch((e) => e.response);

  const { data, status } = respuesta ?? {};

  if (status === 200 || !(data instanceof Blob)) {
    return { data, status };
  }

  try {
    return { data: JSON.parse(await data.text()), status };
  } catch {
    return { data: null, status };
  }
};
